'use strict';
/**
 * A service to get and return sleep-related data.
 */

angular.module('msSleep').service('sleepEntrySvc', ['httpSvc', 'STANDARD_DATE_FMT', function (httpSvc, STANDARD_DATE_FMT) {

  function getEntries(startDate, endDate, completionCheck) {
    completionCheck = completionCheck || 'false';
    var start = moment(startDate).format(STANDARD_DATE_FMT);
    var end = moment(endDate).format(STANDARD_DATE_FMT);
    return httpSvc.get('/apiproxy/user/sleepdiary?&completionCheck=' + completionCheck + '&start=' + start + '&end=' + end);
  }

  function getAllEntries() {
    return httpSvc.get('/apiproxy/user/sleepdiary/all');
  }

  function getEntry(day) {
    return httpSvc.get('/apiproxy/user/sleepdiary/' + day);
  }

  function getMostRecentEntry() {
    return httpSvc.get('/apiproxy/user/sleepdiary/mostrecent');
  }

  function save(request) {
    return httpSvc.post('/apiproxy/user/sleepdiary', request);
  }

  return {
    getEntry: getEntry,
    getEntries: getEntries,
    getMostRecentEntry: getMostRecentEntry,
    getAllEntries: getAllEntries,
    save: save
  };
}]);